import { FC } from "react";
import {
  SessionItem,
  SessionItemKind,
  SessionRenderingContext,
} from "@/mds/components/sessions/session-item";
import { StandardSessionItemRenderer } from "@/mds/components/sessions/session-item/standard/standard-session-item-renderer";
import { ReasoningGroupSessionItemRenderer } from "@/mds/components/sessions/session-item/reasoning-group";

interface Props {
  item: SessionItem;
  context: SessionRenderingContext;
}

export const SessionItemContent: FC<Props> = ({ item, context }) => {
  switch (item.kind) {
    case SessionItemKind.Standard:
      return <StandardSessionItemRenderer item={item} context={context} />;
    case SessionItemKind.ReasoningGroup:
      return <ReasoningGroupSessionItemRenderer item={item} context={context} />;
    default:
      return null;
  }
};
